// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__3FZtH"};